import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar";

const HelpAndSupportLayout = () => {
  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};

export default HelpAndSupportLayout;
